import { xhrApiClient } from '@/config/xhrApiClient'

const postPhoneVerificationVerify = async (payload: any) => {
    const { data } = await xhrApiClient.post(
        '/api/phone-verification/verify',
        payload
    )
    return data
}

export default postPhoneVerificationVerify
